export const policyModeBadgeVariant = (
  mode: string | null
): "warning" | "default" | "destructive" | "success" | "secondary" => {
  if (mode === "require_approval") return "warning";
  if (mode === "conditional") return "default";
  if (mode === "deny") return "destructive";
  if (mode === "allow") return "success";
  return "secondary";
};

export const policyModeLabel = (mode: string | null) => {
  if (mode === null) return null;
  const labels: Record<string, string> = {
    require_approval: "Requires approval",
    conditional: "Conditional",
    deny: "Deny",
    allow: "Allow"
  };
  return labels[mode] ?? mode.replaceAll("_", " ");
};

export type ExpiryPresentation = {
  label: string;
  urgent: boolean;
  expired: boolean;
};

export const formatExpiry = (iso: string): ExpiryPresentation => {
  const ms = new Date(iso).getTime() - Date.now();
  if (Number.isNaN(ms)) {
    return { label: iso, urgent: false, expired: false };
  }
  if (ms <= 0) {
    return { label: "Expired", urgent: true, expired: true };
  }
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 60) {
    return {
      label: `${String(minutes)}m left`,
      urgent: minutes < 10,
      expired: false
    };
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 48) {
    return { label: `${String(hours)}h left`, urgent: false, expired: false };
  }
  const days = Math.floor(hours / 24);
  return { label: `${String(days)}d left`, urgent: false, expired: false };
};
